<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="onSubmit")
    modal(active, title="Concluir análise", @close="$router.back()")
      div(slot="modal-body")
        p Você está #[b concluindo a análise], selecione qual o resultado da análise.
        p Este processo #[b não é reversível].
        form-group(
          :label="'ordem_servico_analise.parecer' | tModel",
          :validation="$v.form.parecer"
        )
          textarea.form-input(
            rows="2",
            placeholder="Informe aqui o seu parecer",
            v-model.trim="$v.form.parecer.$model",
            v-autofocus
          )
        .form-group
          label.text-small
            | Qual é o resultado da análise? #[span.text-error *]
          label.form-radio(v-for="value in situacoes")
            input(type="radio", v-model="form.situacao", :value="value")
            i.form-icon
            | {{ $i18n.t(`enums.db.enum_ordem_servico_analise_situacao.${value}`) }}
      div(slot="modal-footer")
        button.btn.btn-success(
          :disabled="$v.form.$invalid",
          :class="{ loading }"
        )
          btn-content(icon="fa fa-check", label="Concluir análise")
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    "analises/minhasAnalises": {
      getters: ["loading"],
      state: ["current"],
      actions: ["fetchUpdate"],
    },
  },
  data() {
    return {
      form: {
        parecer: "",
        situacao: "",
      },
    }
  },
  computed: {
    situacoes() {
      const ignore = [
        "nenhuma",
        "aguardando",
        "cancelado",
        "reabertura",
        "reanalise",
      ]
      return Object.keys(
        this.$i18n.t("enums.db.enum_ordem_servico_analise_situacao"),
      ).filter(key => !ignore.includes(key))
    },
  },
  methods: {
    async onSubmit() {
      try {
        const data = {
          id: this.current.id,
          ...this.form,
        }
        await this.fetchUpdate(data)
        this.$toaster.success("Análise concluída")
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  validations: {
    form: {
      parecer: { minLength: minLength(10), required },
    },
  },
}
</script>
